import { ErrorTemplateBuilder } from "./error-template-builder";
import { IndexDBSyncManager } from "./indexdb-sync-manager";

export default class SyncerManager {
  private constructor() {}

  private static _Instance: SyncerManager;

  static get Instance(): SyncerManager {
    if (!this._Instance) {
      this._Instance = new SyncerManager();
    }
    return this._Instance;
  }

  async init() {
    await this.clearAndFillDataFromAPI();
  }

  //#region Private Methods

  private async clearAndFillDataFromAPI() {
    try {
      await IndexDBSyncManager.clearIndexedDBAndReloadData();
    } catch (e) {
      throw new Error(
        ErrorTemplateBuilder.getCatchText(
          "SyncerManager.clearAndFillDataFromAPI",
          e,
        ),
      );
    }
  }

  //#endregion
}
